<template>
  <div>
    <article-entry-no-image :textElements="article" />
  </div>
</template>
<script>
import ArticleEntryNoImage from '@/components/ArticleEntryNoImage';
import { getArticle, getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';
export default {
  components: {
    ArticleEntryNoImage
  },
  metaInfo() {
    return {
      meta: [
        {
          property: 'og:title',
          vmid: 'og-title',
          content: this.article.title
        },
        {
          property: 'og:description',
          vmid: 'og-description',
          content: this.article.subTitle
        }
      ]
    };
  },
  mounted() {
    if (this.$route.meta.article)
      getArticle(this.$route.meta.article).then(res => {
        this.article = translate(res[0]);
      });
    else if (this.$route.meta.articleId) {
      getArticleById(this.$route.meta.articleId).then(res => {
        this.article = translate(res);
      });
    }
  },
  data() {
    return {
      article: {}
    };
  },
  computed: {},
  methods: {}
};
</script>

<style></style>
